import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage as Translation } from 'react-intl';
import { Overlay, css as RUICss } from 'panamera-react-ui';
import Button from 'Components/Button/Button';
import withLocalStorage from 'HOCs/withLocalStorage/withLocalStorage';
import withTrack from 'HOCs/withTrack/withTrack';
import ifConfig from 'HOCs/ifConfig/ifConfig';
import withConfig from 'HOCs/withConfig/withConfig';
import { configSelector } from 'Selectors/config';
import css from './ReskinOnboarding.scss';

const { icons } = RUICss;
const RESKIN_ONBOARDING_ACK = 'RESKIN_ONBOARDING_ACK';

export class ReskinOnboarding extends React.Component {
    static propTypes = {
        localStorage: PropTypes.shape({
            getItem: PropTypes.func.isRequired,
            setItem: PropTypes.func.isRequired
        }).isRequired,
        config: PropTypes.shape({
            get: PropTypes.func.isRequired
        }).isRequired,
        track: PropTypes.func.isRequired,
        configGeneral: PropTypes.object.isRequired
    };

    componentDidMount() {
        if (this.isReturningVisitor()) {
            if (this.isFirstTimeNewLook()) {
                this.setState({ // eslint-disable-line react/no-did-mount-set-state
                    show: true
                });
                this.props.track('popup_reskin_show');
            }
        }
        else {
            this.props.localStorage.setItem(RESKIN_ONBOARDING_ACK, 'true');
        }
    }

    state = {};

    isReturningVisitor() {
        return (document || {}).cookies || !!this.props.localStorage.getItem('RESULT_SET_ID_STORAGE_KEY');
    }

    isFirstTimeNewLook() {
        return !this.props.localStorage.getItem(RESKIN_ONBOARDING_ACK);
    }

    handleLearnMoreClick = () => {
        this.props.track('popup_reskin_learnmore');
    };

    handleClose = () => {
        this.props.track('popup_reskin_close');
        this.props.localStorage.setItem(RESKIN_ONBOARDING_ACK, 'true');
        this.setState({
            show: false
        });
    };

    translation = {
        reskinOnboardingText: {
            brand: this.props.config.get('theme', 'brand')
        }
    };

    render() {
        const { config, configGeneral } = this.props;
        const { show } = this.state;
        const brandIcon = config.get('theme', 'icon');
        const countryName = configGeneral
            && configGeneral.location
            && configGeneral.location.country
            && configGeneral.location.country.name;
        const learnMoreHref = configGeneral
            && configGeneral.location
            && configGeneral.location.country
            && configGeneral.location.country.reskinning_learn_more_url;

        if (!show) {
            return null;
        }

        return (
            <Overlay
                isOpened={ true }
                onClose={ this.handleClose }
                contentClassName={ css.content }
            >
                <span
                    className={ classNames(icons.panameraIcons, icons['icon-Cross'], css.close) }
                    onClick={ this.handleClose }
                />
                <div className={ css.header }>
                    <span
                        className={ classNames(icons.panameraIcons, icons[brandIcon], css.logo) }
                    />
                    <span className={ css.country }>
                        { countryName }
                    </span>
                </div>
                <div className={ css.body }>
                    <h2 className={ css.title }>
                        <Translation id="reskinOnboardingTitle" />
                    </h2>
                    <p className={ css.text }>
                        <Translation id="reskinOnboardingText" values={ this.translation.reskinOnboardingText } />
                        { learnMoreHref && (
                            <a
                                className={ css.link }
                                href={ learnMoreHref }
                                onClick={ this.handleLearnMoreClick }
                            >
                                <Translation id="reskinOnboardingLink" />
                            </a>
                        ) }
                    </p>
                    <Button
                        className={ css.button }
                        type="secondaryBtn"
                        invert
                        onClick={ this.handleClose }
                    >
                        <Translation id="reskinOnboardingAction" />
                    </Button>
                </div>
            </Overlay>
        );
    }
}

const mapStateToProps = state => ({
    configGeneral: configSelector(state)
});

export default ifConfig(['theme', 'id'], {
    olx: compose(
        withLocalStorage,
        withConfig,
        withTrack,
        connect(mapStateToProps)
    )(ReskinOnboarding)
});
